import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';

import type { TPayment } from '../../store/types';

export const convertPaymentsToTable = (items: TPayment[]): TPayment[] => {
  const payments: TPayment[] = items.map((item) => ({
    ...item,
    paymentSystemName: item.paymentSystemName ?? 'Свой метод',
    credentials: item.credentials ?? '-',
    created: dayjsCustom(item.created).format('DD.MM.YYYY / HH:mm'),
    // updated: dayjsCustom(item.updated).format('DD.MM.YYYY / HH:mm'),
  }));

  return payments;
};
